import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation, SimpleChanges, Output, EventEmitter } from '@angular/core';
import videojs from 'video.js';
import { VideoPlayerService } from './video-player.service';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class VideoPlayerComponent implements OnInit, OnDestroy {

  @ViewChild('target', { static: true }) target: ElementRef;

  @Input() videoUrl: string;

  @Input() isPause:boolean;

  @Output() onPlay: EventEmitter<boolean> = new EventEmitter();

  defaultVideoUrl: string = 'https://firebasestorage.googleapis.com/v0/b/camedulearning.appspot.com/o/Welcome%20to%20Cam-Edu.mp4?alt=media&token=4e657c01-9354-4c50-908d-734f4a6c7195';

  player: videojs.Player;

  firstLoaded: boolean = false;

  constructor(
    private elementRef: ElementRef,
    private videoPlayerService: VideoPlayerService
  ) { }

  ngOnInit(): void {

    const options = {
      controls: true,
      fluid: true,
      sources: [{
        'src': this.videoUrl === undefined ? this.defaultVideoUrl : this.videoUrl,
        'type': 'video/mp4'
      }
      ],
    };

    this.player = videojs('my-player', options);

    this.onPlayerObserver();

  }

  onPlayerObserver() {
    this.videoPlayerService.onPlay(this.player)
      .then(() => {
        if(this.firstLoaded){
          return;
        }
        this.onPlay.emit(true)
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.videoUrl) {
      this.player.src({ type: 'video/mp4', src: this.videoUrl });
      this.player.ready(function () {
        var myPlayer = this;
        if (!this.firstLoad) {
          this.firstLoad = !this.firstLoad;
          myPlayer.pause();
        } else {
          console.log("Not first");
          myPlayer.play();
        }
      });
    }
    if(this.isPause){
      this.player.pause();
    }
  }

  ngOnDestroy() {
    // destroy player
    if (this.player) {
      this.player.dispose();
    }
  }

}
